module.exports = __webpack_public_path__ + "img/01-T.906c3b7c.png";